import { Card } from 'antd';
import styled from 'styled-components';
import useReportLog from '../hooks/useReportLog';
import { useEffect, useState } from 'react';
import useGroup from '../zustand/useGroup';
import useAppliedReportFilter from '../hooks/useAppliedReportFilter';
import { EReportDataInterval } from '../screens/report/types/report-log.type';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { generateDataCompletion } from '../screens/report/components/helperFunction';

dayjs.extend(utc);
dayjs.extend(timezone);

const InfoDataCompletion = () => {
  const { logs } = useReportLog();
  const { filter, timezone } = useAppliedReportFilter();
  const [data, setData] = useState<any[]>([]);

  const _renderDeviceInfo = (
    device: string,
    valueDevice: any,
    lastDataDevice: any
  ) => {
    return (
      <DeviceInfo key={device}>
        <DeviceInfoLabel>
          {device.toLocaleUpperCase()}: {valueDevice.toFixed(2)}%
        </DeviceInfoLabel>
        <DeviceInfoDate style={{ color: 'grey', marginTop: -5 }}>
          Last Data: {lastDataDevice}
        </DeviceInfoDate>
      </DeviceInfo>
    );
  };

  useEffect(() => {
    let currentDataCompletion: any[] = [];

    if (logs.flowmeter) {
      const obj = logs.flowmeter;
      let count = 0;
      let lastTimestamp = '';
      let completion = {};
      Object.keys(obj).forEach((key) => {
        if (
          obj[key] &&
          obj[key]['portIn'] &&
          obj[key]['portIn']['volumeTotal']
        ) {
          count += 1;
          lastTimestamp = key;
        }
      });
      completion = {
        type: 'flowmeter',
        count,
        lastTimestamp,
      };
      currentDataCompletion = [...currentDataCompletion, completion];
    }
    if (logs.ae) {
      const obj = logs.ae;

      const firstDataKey = Object.values(obj)[0];

      if (firstDataKey && firstDataKey['ae1In']) {
        console.log('aea ae1In exists');
        const completionAe = generateDataCompletion(
          obj,
          'ae',
          'totalFuelConsVolume'
        );

        currentDataCompletion = [...currentDataCompletion, completionAe];
      } else {
        const completionAe = generateDataCompletion(
          obj,
          'ae',
          'totalRunningTime'
        );

        currentDataCompletion = [...currentDataCompletion, completionAe];
      }

      const completionPower = generateDataCompletion(
        obj,
        'ae',
        'totalRunningTime'
      );
      currentDataCompletion = [
        ...currentDataCompletion,
        { ...completionPower, type: 'power' },
      ];
    }
    if (logs.rpm) {
      const obj = logs.rpm;
      const completionRpm = generateDataCompletion(
        obj,
        'rpm',
        'totalRunningTime'
      );
      currentDataCompletion = [...currentDataCompletion, completionRpm];
    }
    if (logs.gps) {
      const obj = logs.gps;
      const completionGps = generateDataCompletion(obj, 'gps', 'latitude');
      currentDataCompletion = [...currentDataCompletion, completionGps];
    }
    if (logs.gateway) {
      const obj = logs.gateway;
      const completionGateway = generateDataCompletion(obj, 'gateway', 'id');
      currentDataCompletion = [...currentDataCompletion, completionGateway];
    }

    if (currentDataCompletion && currentDataCompletion.length) {
      let interval = 0;
      const now = dayjs().unix();
      const startAt = filter.startAt;
      const endAt = filter.endAt;

      if (filter.interval === EReportDataInterval.minute) {
        interval = Math.floor((endAt - startAt) / 60);
      } else if (filter.interval === EReportDataInterval.hour) {
        interval = Math.floor((endAt - startAt) / 3600);
      } else {
        interval = Math.ceil((endAt - startAt) / 86400);
        // if (moment(filter.range.startAt).hours() === 0) {
        //   dataLength = dataLength - 1;
        // }
      }
      const res = currentDataCompletion.map((item) => {
        if (item && item.type) {
          const percentage = (item.count / interval) * 100;
          return {
            ...item,
            lastTimestamp: item.lastTimestamp
              ? dayjs(item.lastTimestamp * 1000)
                  .utcOffset(timezone * 60)
                  .format('DD MMM YYYY HH:mm')
              : 'N/A',
            percentage: percentage > 100 ? 100 : percentage,
          };
        }
      });
      setData(res);
    }
  }, [logs, filter.startAt, filter.endAt, filter.interval, timezone]);

  return (
    <InfoPercentage>
      {data
        .filter((item) => item && item.type)
        .map((item) => {
          return _renderDeviceInfo(
            item.type,
            item.percentage,
            item.lastTimestamp
          );
        })}
    </InfoPercentage>
  );
};

const InfoPercentage = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DeviceInfo = styled.div`
  flex: 1;
  border-right: 1px solid #ebebeb;
  padding-bottom: 5px;

  :last-child {
    border-right: none;
  }
`;

const DeviceInfoLabel = styled.div`
  font-size: 12px;
  margin-bottom: 8px;
`;

const DeviceInfoDate = styled.div`
  font-size: 10px;
  color: var(--gray-1);
`;

export default InfoDataCompletion;
